export const appWhitelist = [
  ['setToken'],
  ['logout'],
  ['trainingRecord'],
  ['examRecord'],
  ['training']
]



// WEBPACK FOOTER //
// ./src/store/utils/app_whitelist.js